// Camera constraints utility following SOLID principles
// Single Responsibility: Only handles camera constraints selection
// Open/Closed: Can add more strategies for new device types
// Liskov: All strategies return valid constraints
// Interface Segregation: Only exposes getCameraConstraints
// Dependency Inversion: Consumers depend on this abstraction

/**
 * Detect if the device is mobile (basic check)
 */
export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;
  return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

/**
 * Get camera constraints based on device type
 * @returns {MediaStreamConstraints}
 */
export function getCameraConstraints() {
  if (isMobileDevice()) {
    // Mobile: medium-high resolution for better face blendshape fidelity,
    // while keeping browser fallback room on lower-end devices.
    return {
      video: {
        facingMode: 'user',
        width: { ideal: 1280, min: 960, max: 1920 },
        height: { ideal: 720, min: 540, max: 1080 },
        frameRate: { ideal: 30, min: 24, max: 30 },
        aspectRatio: { ideal: 16 / 9 },
      },
      audio: false,
    };
  }
  // Desktop: high res, 16:9 preferred
  return {
    video: {
      width: { ideal: 1920 },
      height: { ideal: 1080 },
      facingMode: 'user',
      aspectRatio: 16/9,
    },
    audio: false,
  };
}

/**
 * Get recommended video style for the video element
 * @returns {object}
 */
export function getVideoElementStyle(baseStyle = {}) {
  if (isMobileDevice()) {
    // On mobile, use contain to avoid cropping face
    return { ...baseStyle, objectFit: 'contain' };
  }
  // On desktop, use cover for immersive experience
  return { ...baseStyle, objectFit: 'cover' };
}